import { createGetAsyncSlice } from '@sonar-software/xuder';
import { getCustomerFeatureFlags } from '@api';

export const coreCustomersByIdFeatureFlagsGetSlice = createGetAsyncSlice({
	name: 'CoreCustomersByIdFeatureFlags',
	receive: true,
	request: true,
	requestHandler: getCustomerFeatureFlags,
	retainDataOnRequest: true
});
